window.heistAnalytics = {
  itemFromElement(el) {
    if (!el || !el.dataset.gaItemId) return null;

    const { dataset } = el;
    return {
      item_id: dataset.gaItemId,
      item_name: dataset.gaItemName,
      item_brand: dataset.gaItemBrand,
      item_category: dataset.gaItemCategory,
      item_variant: dataset.gaItemVariant,
      price: Number(dataset.gaPrice) / 100,
      discount: Number(dataset.gaDiscount) / 100,
    };
  },

  pushRemoveFromCart(item, removedQty) {
    if (!item || !(removedQty > 0)) return;

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "remove_from_cart",
        ecommerce: {
          currency: window.Shopify?.currency?.active,
          value: Number((item.price * removedQty).toFixed(2)),
          items: [{ ...item, quantity: removedQty }],
        },
      });
    } catch (error) {
      console.warn("[analytics] remove_from_cart push failed", error);
    }
  },

  pushOpenSizeChart(details) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "open_size_chart",
        ...details,
      });
    } catch (error) {
      console.warn("[analytics] open_size_chart push failed", error);
    }
  },

  pushOpenAccordion(details) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "open_accordion",
        ...details,
      });
    } catch (error) {
      console.warn("[analytics] open_accordion push failed", error);
    }
  },

  pushExpandReviews(details) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "expand_review",
        ...details,
      });
    } catch (error) {
      console.warn("[analytics] expand_review push failed", error);
    }
  },

  pushOpenFullscreenGallery(details) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "open_fullscreen_gallery",
        ...details,
      });
    } catch (error) {
      console.warn("[analytics] open_fullscreen_gallery push failed", error);
    }
  },

  pushNavigateGallery(details) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "navigate_gallery",
        ...details,
      });
    } catch (error) {
      console.warn("[analytics] navigate_gallery push failed", error);
    }
  },

  pushClickNavigation(details) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "click_navigation",
        ...details,
      });
    } catch (error) {
      console.warn("[analytics] click_navigation push failed", error);
    }
  },

  pushClickPromoBanner(details) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "click_promo_banner",
        ...details,
      });
    } catch (error) {
      console.warn("[analytics] click_promo_banner push failed", error);
    }
  },
};
